export const en = {
  ns1: {
    "A newer version of the app opened a window. Reload to continue.":
      "A newer version of the app opened a window. Reload to continue.",
    Reload: "Reload",
    "Could not load local servers": "Could not load local servers",
    "Toasts won't appear on small screens. Only the bell icon will show a notification in that case.":
      "Toasts won't appear on small screens. Only the bell icon will show a notification in that case.",
    "Toast notifications remain on the screen until dismissed. Critical notifications will appear in red.":
      "Toast notifications remain on the screen until dismissed. Critical notifications will appear in red.",
    "No internet connection": "No internet connection",
    pen_with_id: "Pen {{cageId}}",
    "Failed to move camera": "Failed to move camera",
    "Failed to save preset": "Failed to save preset",
    "Failed to delete preset": "Failed to delete preset",
    "Save camera preset": "Save camera preset",
    "These coordinates will be saved with the preset.":
      "These coordinates will be saved with the preset.",
    "X offset": "X offset",
    "e.g. North feed point": "e.g. North feed point",
    "Delete preset": "Delete preset",
    "Preset name": "Preset name",
    Required: "Required",
    "Configure cage dimensions to view the digital twin":
      "Configure cage dimensions to view the digital twin",
    Expand: "Expand",
    Collapse: "Collapse",
    "Expand digital twin": "Expand digital twin",
    "Add to favourites": "Add to favourites",
    "Remove from favourites": "Remove from favourites",
    "Return to live": "Return to live",
    "Loading chart data...": "Loading chart data...",
    "Error loading data": "Error loading data",
    Recording: "Recording",
    "Event clip": "Event clip",
    server_not_found: "No server found at {{ip}}:{{port}}.",
    "Feeding only": "Feeding only",
    Map: "Map",
    User: "User",
    Users: "Users",
    Logout: "Logout",
    "No sites available": "No sites available",
    "Loading sites": "Loading sites",
    "No site selected_other": "No sites selected",
    "No site selected_one": "No site selected",
    "Are you sure?": "Are you sure?",
    "This action is irreversible.": "This action is irreversible.",
    Delete: "Delete",
    Events: "Events",
    "No data available": "No data available",
    "No data for the selected time frame":
      "No data for the selected time frame",
    "New Scenario": "New Scenario",
    "New Strategy": "New Strategy",
    "Rename Strategy": "Rename Strategy",
    "Add Strategy": "Add Strategy",
    "Add Scenario": "Add Scenario",
    "Edit Scenario": "Edit Scenario",
    "Delete Scenario": "Delete Scenario",
    "Delete Strategy": "Delete Strategy",
    "Rename Scenario": "Rename Scenario",
    New: "New",
    "New from": "New from",
    "No events in the last 15 minutes": "No events in the last 15 minutes",
    "Loading events": "Loading events",
    Unit: "Unit",
    Pens: "Pens",
    Pen: "Pen",
    Sites: "Sites",
    All: "All",
    Units: "Units",
    Reasons: "Reasons",
    "Manual Feeding": "Manual Feeding",
    "Observe Feeding": "Observe Feeding",
    "Planned Feeding": "Planned Feeding",
    "Disabled Feeding": "Disabled Feeding",
    "Feed actions": "Feed actions",
    "No data available for current filter(s)":
      "No data available for current filter(s)",
    "Air speed": "Air speed",
    Silo: "Silo",
    Visits: "Visits",
    Visit: "Visit",
    Automation: "Automation",
    Auto: "Auto",
    "Live Feeding": "Live Feeding",
    Live: "Live",
    Analytics: "Analytics",
    Data: "Data",
    "Activity change": "Activity change",
    Alert: "Alert",
    "Automation: Scenario change": "Automation: Scenario change",
    "Manual scenario change": "Manual scenario change",
    "Feeding system change": "Feeding system change",
    "Oxygen change": "Oxygen change",
    "Salinity change": "Salinity change",
    "Temperature change": "Temperature change",
    "Multiple sites": "Multiple sites",
    "All units": "All units",
    numberOfUnits: "{{numberOfUnits}} units",
    unitId: "Unit {{unit}}",
    "Invalid username or password": "Invalid username or password",
    "Your password needs to be reset. You will have received a verification code in your email.":
      "Your password needs to be reset. You will have received a verification code in your email.",
    "If the account exists, you will have received a verification code in your email.":
      "If the account exists, you will have received a verification code in your email.",
    "Invalid code or session": "Invalid code or session",
    "Password successfully changed": "Password successfully changed",
    "Invalid new password": "Invalid new password",
    "Password has been successfully changed. Use to log in from now on.":
      "Password has been successfully changed. Use to log in from now on.",
    "OTP client successfully set up. Now you can log in":
      "OTP client successfully set up. Now you can log in",
    "Could not set up the OTP client": "Could not set up the OTP client",
    "Feed units": "Feed units",
    Filter: "Filter",
    "No units are feeding at the moment": "No units are feeding at the moment",
    "No units available": "No units available",
    "Remove filter": "Remove filter",
    "Feeding mode": "Feeding mode",
    Strategy: "Strategy",
    Scenario: "Scenario",
    "Strategies not synced": "Strategies not synced",
    Overview: "Overview",
    "Search site": "Search site",
    "No results": "No results",
    "Select All": "Select All",
    Loading: "Loading",
    "Alert Groups": "Alert Groups",
    "No groups found": "No groups found",
    Cancel: "Cancel",
    Save: "Save",
    "Discard changes?": "Discard changes?",
    "You'll lose all changes made to this scenario":
      "You'll lose all changes made to this scenario",
    "More Than": "More Than",
    "Less Than": "Less Than",
    Calendar: "Calendar",
    Rotas: "Rotas",
    Comments: "Comments",
    "Clear Rota": "Clear Rota",
    "Add Rota": "Add Rota",
    Farmer: "Farmer",
    "Create Farmer": "Create Farmer",
    "Add rota": "Add rota",
    "rota will be overwritten_one": "{{count}} rotas will be overwritten",
    "rota will be overwritten_other": "{{count}} rotas will be overwritten",
    Warning: "Warning",
    "Email already exists": "Email already exists",
    "Error creating user": "Error creating user",
    "Error creating rota": "Error creating rota",
    Comment: "Comment",
    "To Comment": "Comment",
    "Add comment": "Add comment",
    Presets: "Presets",
    Submit: "Submit",
    "Error creating comment": "Error creating comment",
    Now: "Now",
    "All day": "All day",
    "No comments": "No comments",
    Goals: "Goals",
    Subgoal: "Subgoal",
    Score: "Score",
    "See Examples": "See Examples",
    "Show Conditions": "Show Conditions",
    Disable: "Disable",
    Enable: "Enable",
    "No goals found": "No goals found",
    "No data": "No data",
    "Save Changes": "Save Changes",
    "Couldn't update configuration.": "Couldn't update configuration.",
    "No configuration available for this goal.":
      "No configuration available for this goal.",
    "Configuration updated successfully.":
      "Configuration updated successfully.",
    "No pens were updated. Changes apply only to active (non-fallowed) pens.":
      "No pens were updated. Changes apply only to active (non-fallowed) pens.",
    Example: "Example",
    Breakdown: "Breakdown",
    "No breakdown available": "No breakdown available",
    "Sort by": "Sort by",
    "Date: Newest to Oldest": "Date: Newest to Oldest",
    "Date: Oldest to Newest": "Date: Oldest to Newest",
    "Score: Best to Worst": "Score: Best to Worst",
    "Score: Worst to Best": "Score: Worst to Best",
    Evidence: "Evidence",
    Filters: "Filters",
    "Configurations updated successfully":
      "Configurations updated successfully",
    "No evidence found for this date range":
      "No evidence found for this date range",
    "Access Denied": "Access Denied",
    "You don't have access to this page": "You don't have access to this page",
    "Please contact your administrator": "Please contact your administrator",
    or: "or",
    "Sign out": "Sign out",
    Summary: "Summary",
    "Shift Analysis": "Shift Analysis",
    "Days of note for": "Days of note for {{name}}",
    "Pens for": "Pens for {{name}}",
    Analyse: "Analyse",
    "Highest Performing Sites": "Highest Performing Sites",
    "Lowest Performing Sites": "Lowest Performing Sites",
    Goal: "Goal",
    "No sites with scores found": "No sites with scores found",
    "Camera Automation": "Camera Automation",
    Camera: "Camera",
    "Feed Automation": "Feed Automation",
    Feed: "Feed",
    Feeding: "Feeding",
    Defaults: "Defaults",
    Line: "Line",
    "Feed Rate (Kg/min)": "Feed Rate (Kg/min)",
    "Visit (Kgs)": "Visit (Kgs)",
    "No strategies found": "No strategies found",
    "When pen": "When pen",
    "is feeding, use preset": "is feeding, use preset",
    "Add Preset": "Add Preset",
    "Edit Preset": "Edit Preset",
    Add: "Add",
    Edit: "Edit",
    Configuration: "Configuration",
    admin_configuration: "Admin Configuration",
    notifications_center: "Notifications Center",
    notifications_center_message:
      "This page allows you to subscribe and configure alerts directly to your email and longer form optimisation reports",
    notification_updated_successfully: "Notification updated successfully.",
    When: "When",
    "is feeding": "is feeding",
    "use preset": "use preset",
    "You will no longer see scores for":
      "You will no longer see scores for {{name}} from here onwards",
    "Error deleting comment": "Error deleting comment",
    "Daily Average": "Daily Average",
    "No sites selected": "No sites selected",
    environmental: "Environmental",
    predators: "Predators",
    camera: "Camera Hardware Issue",
    feed_system: "Feed System Issue",
    net_cleaning: "Net Cleaning",
    mortality: "Mortality",
    other: "Other",
    Alerts: "Alerts",
    "Remove Pin": "Remove Pin",
    "This pen": "This pen",
    "Alerts on this pen": "Alerts on this pen",
    "Alerts on {{feedline}}": "Alerts on {{feedline}}",
    "Pinned to {{feedline}}": "Pinned to {{feedline}}",
    "Will move pin from another cell": "Will move pin from another cell",
    "{{name}} (current)": "{{name}} (current)",
    "{{provider}} Planner": "{{provider}} Planner",
    Pellets: "Pellets",
    Activity: "Activity",
    Language: "Language",
    Oxygen: "Oxygen",
    Graph: "Graph",
    "Feed Graph": "Feed Graph",
    "Pressure Graph": "Pressure Graph",
    "Feed Amount": "Feed Amount",
    "Feed Rate": "Feed Rate",
    "Set Feed Rate": "Set Feed Rate",
    "Enter feed rate": "Enter feed rate",
    "Feed Status": "Feed Status",
    "Feed target": "Feed target",
    "Appetite Factor": "Appetite Factor",
    "Stopping Depth": "Stopping Depth",
    Shifts: "Shifts",
    "Create User": "Create User",
    Confirm: "Confirm",
    "First name": "First name",
    "Last name": "Last name",
    Email: "Email",
    Emails: "Emails",
    "Email Type": "Email Type",
    Depth: "Depth",
    Name: "Name",
    Create: "Create",
    Rename: "Rename",
    Dome: "Dome",
    Descent: "Descent",
    Type: "Type",
    "Add Starting Depth": "Add Starting Depth",
    "Add Stopping Depth": "Add Stopping Depth",
    "Add Depth": "Add Depth",
    "Continuously rotate camera": "Continuously rotate camera",
    "Tilt camera down before rotation": "Tilt camera down before rotation",
    "Rotate for": "Rotate for",
    "Pause Between": "Pause Between",
    "Alternate Direction Each Sweep": "Alternate Direction Each Sweep",
    "Sweeps Each Direction": "Sweeps Each Direction",
    "Go to starting position (end of visit)":
      "Go to starting position (end of visit)",
    "Point camera down": "Point camera down",
    "depth must be bellow": "Depth must be below {{maxDepth}}m",
    "depth must be above": "Depth must be above {{minDepth}}m",
    "Depth is already used": "Depth is already used",
    "What should the camera do?": "What should the camera do?",
    "What depth?": "What depth?",
    "When does the camera go up?": "When does the camera go up?",
    "When does the camera go down?": "When does the camera go down?",
    en: "English",
    es: "Español",
    no: "Norsk",
    Columns: "Columns",
    Total: "Total",
    "Best Score": "Best Score",
    "Worst Score": "Worst Score",
    Site: "Site",
    Machine: "Machine",
    Weeks: "Weeks",
    "Least Pellets": "Least Pellets",
    "Most Pellets": "Most Pellets",
    "Pellets & Alerts": "Pellets & Alerts",
    "Pellets/Alert": "Pellets/Alert",
    "Severity [%]": "Severity [%]",
    "Feed Amount [kg]": "Feed Amount [kg]",
    "Feed Rate [kg/min]": "Feed Rate [kg/min]",
    "Feed Time [min]": "Feed Time [min]",
    "Feed Dose [kg]": "Feed Dose [kg]",
    "Feed Amount/Pellet [kg/Pellet]": "Feed/Pellet [kg/Pellet]",
    "Alert Responsiveness": "Alert Responsiveness",
    "Total Responsiveness [%]": "Total Responsiveness [%]",
    "Camera Responsiveness [%]": "Camera Responsiveness [%]",
    "Feeding Responsiveness [%]": "Feeding Responsiveness [%]",
    "Alert Activity [%]": "Alert Activity  [%]",
    "Feeding Activity [%]": "Feeding Activity  [%]",
    "Camera Depth": "Camera Depth",
    "Camera Action": "Camera Action",
    "Hold & watch": "Hold & watch",
    "Rotate to scan": "Rotate to scan",
    "Camera Movement": "Camera Movement",
    "Depth increasing": "Depth increasing",
    "Depth decreasing": "Depth decreasing",
    Temperature: "Temperature",
    "Pipe Pressure": "Pipe Pressure",
    "Feeding Depth": "Feeding Depth [m]",
    "Alert Depth": "Alert Depth [m]",
    Sensors: "Sensors",
    "Selected sensor is unavailable, showing another source":
      "Selected sensor is unavailable, showing another source",
    Automatic: "Automatic",
    "camera's own": "camera's own",
    "No sensor of this type on the pen": "No sensor of this type on the pen",
    "Failed to save the camera's sensor": "Failed to save the camera's sensor",
    "Sensors this camera reads": "Sensors this camera reads",
    "Sensors at camera depth": "Sensors at camera depth",
    "Save to choose sensors for the new pen":
      "Save to choose sensors for the new pen",
    "Could not load this camera's sensors":
      "Could not load this camera's sensors",
    Custom: "Custom",
    "None on this pen": "None on this pen",
    Winch: "Winch",
    "Advanced settings": "Advanced settings",
    "Assign this camera to a pen to choose its sensors":
      "Assign this camera to a pen to choose its sensors",
    "Edit Camera": "Edit Camera",
    "Add Camera": "Add Camera",
    "Edit Winch": "Edit Winch",
    "Add Winch": "Add Winch",
    "Winch Type": "Winch Type",
    "Edit Pen": "Edit Pen",
    "Add Pen": "Add Pen",
    "Edit Sensor": "Edit Sensor",
    "Add Sensor": "Add Sensor",
    Connected: "Connected",
    "Not connected": "Not connected",
    "Oxygen 0-6m": "Oxygen 0-6m",
    "Feeding Oxygen 0-6m": "Feeding Oxygen 0-6m",
    "Temperature 0-6m": "Temperature 0-6m",
    "Most Feed Amount/Pellet": "Most Feed/Pellet",
    "Least Feed Amount/Pellet": "Least Feed/Pellet",
    Biomass: "Biomass",
    "Average Growth [kg]": "Average Growth [kg]",
    "Average Weight [kg]": "Average Weight [kg]",
    "Highest Weight [kg]": "Highest Weight [kg]",
    "Lowest Weight [kg]": "Lowest Weight [kg]",
    "Highest Growth [kg]": "Highest Growth [kg]",
    "Lowest Growth [kg]": "Lowest Growth [kg]",
    "Site has no cages": "Site has no pens",
    "Create Pause": "Create Pause",
    "Edit Pause": "Edit Pause",
    "Seconds to Pause": "Seconds to Pause",
    "This site is not running the latest Marlin. Upgrade for the latest features.":
      "This site is not running the latest Marlin. Upgrade for the latest features.",
    Notification_updated_successfully: "Notification updated successfully",
    "Admin Configuration": "Admin Configuration",
    Notifications: "Notifications",
    Groups: "Groups",
    "Show scheduler visit groups": "Show scheduler visit groups",
    "Group {{number}} · {{start}}–{{end}} · {{visits}} visits · {{percent}}%":
      "Group {{number}} · {{start}}–{{end}} · {{visits}} visits · {{percent}}%",
    "Start feeding": "Start feeding",
    "Pause feeding": "Pause feeding",
    "Stop feeding": "Stop feeding",
    "More options": "More options",
    "Reset to original schedule": "Reset to original schedule",
    "Stop feed for the whole day": "Stop feed for the whole day",
    Catchup: "Catchup",
    "Restores all planned feed after now":
      "Restores all planned feed after now",
    "Not currently allowed in micro feeding":
      "Not currently allowed in micro feeding",
    "Main Menu": "Main Menu",
    Support: "Support",
    Integrations: "Integrations",
    "Copy from site": "Copy from site",
    Copy: "Copy",
    Local: "Local",
    Servers: "Servers",
    "Local Servers": "Local Servers",
    "Local Configuration": "Local Configuration",
    "Add server": "Add server",
    Port: "Port",
    Connection: "Connection",
    "for more than": "for more than",
    for: "for",
    seconds: "seconds",
    "User sites": "User sites",
    "User permission groups": "User permission groups",
    "Something has gone wrong": "Something has gone wrong",
    Error: "Error",
    Refresh: "Refresh",
    Retry: "Retry",
    "This page could not be loaded": "This page could not be loaded",
    "Could not connect to the server": "Could not connect to the server",
    "The app could not start": "The app could not start",
    "Try again. If it keeps happening, contact support.":
      "Try again. If it keeps happening, contact support.",
    "Check your network connection and try again.":
      "Check your network connection and try again.",
    "You cannot change your own permissions":
      "You cannot change your own permissions",
    "Data Router": "Data Router",
    "Equipment Integration": "Equipment Integration",
    feed_service: "Feed Service",
    camera_service: "Camera Service",
    "integration for": "Integration for",
    "Page Not Found": "Page Not Found",
    "The page you are looking for doesn't exist":
      "The page you are looking for doesn't exist",
    "Please check the URL or try navigating to another page":
      "Please check the URL or try navigating to another page",
    "Go to Home": "Go to Home",
    Video: "Video",
    "Video Page Layout": "Video Page Layout",
    "Camera Layout": "Camera Layout",
    "Video Aspect Ratio": "Video Aspect Ratio",
    Original: "Original",
    Stretch: "Stretch",
    Crop: "Crop",
    cage_id: "Pen Id",
    "Screen Configuration": "Screen Configuration",
    "Save Current Configuration": "Save Current",
    "Reset to Default Configuration": "Reset Screens",
    "Save Current Configuration Description":
      "Remembers which screens are visible when you reopen the app",
    "Default Graph Time Range": "Default Graph Time Range",
    "Camera in Camera": "Camera in Camera",
    "Camera size": "Camera size",
    Small: "Small",
    Medium: "Medium",
    Large: "Large",
    "Pellet Detection": "Pellet Detection",
    "Render Detections": "Render Detections",
    None: "None",
    "Reset to Default Configuration Description":
      "Returns to showing all screens by default",
    "Saving...": "Saving...",
    "Resetting...": "Resetting...",
    "Saved!": "Saved!",
    Troubleshooting: "Troubleshooting",
    "Notification Settings": "Notification Settings",
    "Video Page Settings": "Video Page Settings",
    General: "General",
    "Default Info Rows": "Default Info Rows",
    "Reset to defaults": "Reset to defaults",
    "Saving replaces the info rows on every camera on the video page.":
      "Saving replaces the info rows on every camera on the video page.",
    "Row 1": "Row 1",
    "Row 2": "Row 2",
    "Row 3": "Row 3",
    "Time range": "Time range",
    "Settings saved successfully": "Settings saved successfully",
    "Failed to save settings": "Failed to save settings",
    "Failed to load settings": "Failed to load settings",
    Settings: "Settings",
    use_acv4_mapping: "Move cameras in ACV4 to move in Observe",
    use_observe_endpoints: "Use Observe API endpoints (default: SEAV)",
    "Welcome to Observe Tide!": "Welcome to Observe Tide!",
    "Use the ": "Use the ",
    "to select a page": "to select a page",
    "within a span of": "within a span of",
    "Download Config": "Download Config",
    "Upload Config": "Upload Config",
    feeding: "Feeding",
    general_info: "General Info",
    equipment_challenges: "Equipment Challenges",
    treatment: "Treatment",
    harvest: "Harvest",
    "Visit created": "Visit created",
    "Visit deleted": "Visit deleted",
    "Feeding Settings": "Feeding Settings",
    Copilot: "Copilot",
    Manual: "Manual",
    Overfeeding: "Overfeeding",
    Underfeeding: "Underfeeding",
    Standardization: "Standardization",
    Grazing: "Grazing",
    Satiation: "Satiation",
    Severity: "Severity",
    create_new: "Create New",
    "Limit Grazing": "Limit Grazing",
    "Camera Movements": "Camera Movements",
    "Feed Profile Smoothness": "Feed Profile Smoothness",
    "Feeding Response": "Feeding Response",
    "Pellet Spike": "Pellet Spike",
    "Feed Amount/Pellet": "Feed Amount/Pellet",
    "Pellets/Feed Amount": "Pellets/Feed Amount",
    "Overfeeding Feed Deviation": "Overfeeding Feed Deviation",
    "Underfeeding Feed Deviation": "Underfeeding Feed Deviation",
    "Are there any pellet spikes?": "Are there any pellet spikes?",
    "Which units stand out?": "Which units stand out?",
    "Which days of feeding should I pay attention to?":
      "Which days of feeding should I pay attention to?",
    "Is the feed rate adapting to the fish enough?":
      "Is the feed rate adapting to the fish enough?",
    "Where could we potentially push the feeding further?":
      "Where could we potentially push the feeding further?",
    "Are the cameras being optimally positioned?":
      "Are the cameras being optimally positioned?",
    "What trends are consistent on my site?":
      "What trends are consistent on my site?",
    "What would you like to track?": "What would you like to track?",
    Address: "Address",
    Cloud: "Cloud",
    Dashboard: "Dashboard",
    Default: "Default",
    Group: "Group",
    "Integration provider": "Integration provider",
    License: "License",
    Q: "Q",
    Version: "Version",
    "and this occured": "and this occurred",
    once: "once",
    "times within a span of": "times within a span of",
    "End must be after start": "End must be after start",
    "Can't add a visit in the past": "Can't add a visit in the past",
    "Can't move a visit into the past": "Can't move a visit into the past",
    "Overlaps a visit on this feedline": "Overlaps a visit on this feedline",
    "Pen is at its feed target — no room":
      "Pen is at its feed target — no room",
    "The added visit exceeds the feed amount remaining in this pen":
      "The added visit exceeds the feed amount remaining in this pen",
    "The visit exceeds the feed amount remaining in this pen":
      "The visit exceeds the feed amount remaining in this pen",
    "Can't add a cluster in the past": "Can't add a cluster in the past",
    "Can't move a cluster into the past": "Can't move a cluster into the past",
    "Overlaps another cluster in this pen":
      "Overlaps another cluster in this pen",
    "A cluster must sit inside one feeding group's window":
      "A cluster must sit inside one feeding group's window",
    "Outside the schedule's feeding window":
      "Outside the schedule's feeding window",
    Start: "Start",
    End: "End",
    "Feed · feed rate {{rate}} kg/min × duration · max {{headroom}} kg of {{target}} kg target":
      "Feed · feed rate {{rate}} kg/min × duration · max {{headroom}} kg of {{target}} kg target",
    "Group window {{window}}": "Group window {{window}}",
    "No feeding group covers this window":
      "No feeding group covers this window",
    "{{count}} visits · {{kg}} kg_one": "{{count}} visit · {{kg}} kg",
    "{{count}} visits · {{kg}} kg_other": "{{count}} visits · {{kg}} kg",
    "no visits": "no visits",
    "{{minutes}} min · ~{{cadence}} min apart":
      "{{minutes}} min · ~{{cadence}} min apart",
    "{{minutes}} min": "{{minutes}} min",
    "~{{cadence}} min apart": "~{{cadence}} min apart",
    "{{kg}} kg/visit": "{{kg}} kg/visit",
    optional: "optional",
    "e.g. catch-up feed, vet requested…": "e.g. catch-up feed, vet requested…",
    "e.g. bad weather, pen treated…": "e.g. bad weather, pen treated…",
    "Add visit": "Add visit",
    "Add cluster": "Add cluster",
    "Schedule change rejected": "Schedule change rejected",
    Idle: "Idle",
    "{{count}} pen_one": "{{count}} pen",
    "{{count}} pen_other": "{{count}} pens",
    "Delete this visit?": "Delete this visit?",
    "Delete visit": "Delete visit",
    "Delete this cluster?": "Delete this cluster?",
    "Delete cluster": "Delete cluster",
    "Feed rate (kg/min)": "Feed rate (kg/min)",
    "{{kg}} kg planned": "{{kg}} kg planned",
    "Daily feed target (kg)": "Daily feed target (kg)",
    "Feeding ends": "Feeding ends",
    "Target met": "Target met",
    Close: "Close",
    "Click to change the daily feed target":
      "Click to change the daily feed target",
    "Click to change the feed rate": "Click to change the feed rate",
    "No feedings": "No feedings",
    Blower: "Blower",
    "{{hours}}h {{minutes}}m": "{{hours}}h {{minutes}}m",
    "{{minutes}}m": "{{minutes}}m",
    "Feeding ends {{label}}": "Feeding ends {{label}}",
    "Estimate if fed at appetite factor 1":
      "Estimate if fed at appetite factor 1",
    "Drag to defer the remaining feed to later":
      "Drag to defer the remaining feed to later",
    "Drag to move · click to edit or delete":
      "Drag to move · click to edit or delete",
    "Drag to change the start time": "Drag to change the start time",
    "Drag to extend the remaining feed": "Drag to extend the remaining feed",
    "Drag to extend the cluster": "Drag to extend the cluster",
    "Drag to change the end time": "Drag to change the end time",
    "Feed target met": "Feed target met",
    "{{delta}} kg over target": "{{delta}} kg over target",
    "{{delta}} kg to reach target": "{{delta}} kg to reach target",
    "target {{target}} kg": "target {{target}} kg",
    "View active schedule": "View active schedule",
    "More info": "More info",
    Advanced: "Advanced",
    Fixed: "Fixed",
    "Growth Model": "Growth Model",
    "What would you like to call this default?":
      "What would you like to call this default?",
    "What time does your feeding day start?":
      "What time does your feeding day start?",
    "What time does your feeding day end?":
      "What time does your feeding day end?",
    "How is the daily target determined?":
      "How is the daily target determined?",
    "How much are you aiming to feed today?":
      "How much are you aiming to feed today?",
    "What is your average base feed rate across this day?":
      "What is your average base feed rate across this day?",
    "Allowed overshoot": "Allowed overshoot",
    "Spread feed evenly across the day": "Spread feed evenly across the day",
    "Follow recent feed rate": "Follow recent feed rate",
    "How are the fish fed?": "How are the fish fed?",
    "Meal Feeding": "Meal Feeding",
    "Micro / Cyclic Feeding": "Micro / Cyclic Feeding",
    "Meal Feeding: pellets go out in a few discrete meals across the day. Micro / Cyclic Feeding: feed is spread into many small, repeating deliveries.":
      "Meal Feeding: pellets go out in a few discrete meals across the day. Micro / Cyclic Feeding: feed is spread into many small, repeating deliveries.",
    "Minimum time between visits": "Minimum time between visits",
    "Optional. The shortest gap allowed between two feeding visits on the same cage. Leave blank for no minimum.":
      "Optional. The shortest gap allowed between two feeding visits on the same cage. Leave blank for no minimum.",
    "Total Groups": "Total Groups",
    "Total Visits": "Total Visits",
    "Average Visit": "Average Visit",
    "Group Start Time": "Group Start Time",
    "Group End Time": "Group End Time",
    "Group Feed %": "Group Feed %",
    "Number of Visits": "Number of Visits",
    "Give this feeding plan a name so you can find it later. Something like 'summer plan' or 'small fish' works well.":
      "Give this feeding plan a name so you can find it later. Something like 'summer plan' or 'small fish' works well.",
    "Earliest time of day the fish are allowed to be fed.":
      "Earliest time of day the fish are allowed to be fed.",
    "Latest time of day feeding is allowed. After this, no more pellets go out.":
      "Latest time of day feeding is allowed. After this, no more pellets go out.",
    "Fixed: you type in the total kilograms of feed per day. Growth Model: the system works out the amount from how much the fish weigh and how fast they grow.":
      "Fixed: you type in the total kilograms of feed per day. Growth Model: the system works out the amount from how much the fish weigh and how fast they grow.",
    "Total kilograms of feed to hand out today across every cage on the feedline.":
      "Total kilograms of feed to hand out today across every cage on the feedline.",
    "How fast pellets can be fed, in {{unit}}. This is usually the feeding machine's normal speed.":
      "How fast pellets can be fed, in {{unit}}. This is usually the feeding machine's normal speed.",
    "Defaults use kg/min or g/s. Change unit in Feed Settings to use {{unit}}.":
      "Defaults use kg/min or g/s. Change unit in Feed Settings to use {{unit}}.",
    "No default": "No default",
    "How much extra above the daily target the system may feed if the fish are still hungry. 15% means it can go up to 15% over the target.":
      "How much extra above the daily target the system may feed if the fish are still hungry. 15% means it can go up to 15% over the target.",
    "ON: visits are packed tightly across the day so feeding time is used efficiently. OFF: visits stay inside the group time windows you set.":
      "ON: visits are packed tightly across the day so feeding time is used efficiently. OFF: visits stay inside the group time windows you set.",
    "Only matters when you add a new cage to the feedline. ON: the new cage keeps the feed rate the other cages were already using. OFF: the new cage starts from the base feed rate above.":
      "Only matters when you add a new cage to the feedline. ON: the new cage keeps the feed rate the other cages were already using. OFF: the new cage starts from the base feed rate above.",
    "How many feeding sessions per day you have set up below.":
      "How many feeding sessions per day you have set up below.",
    "Total number of pellet deliveries across the whole day.":
      "Total number of pellet deliveries across the whole day.",
    "Average kilograms of feed handed out per visit. Just the daily target split evenly across all visits.":
      "Average kilograms of feed handed out per visit. Just the daily target split evenly across all visits.",
    "Time this group of feeding visits begins.":
      "Time this group of feeding visits begins.",
    "Time this group of feeding visits ends.":
      "Time this group of feeding visits ends.",
    "Share of the daily target that belongs to this group. All groups together should add up to 100%.":
      "Share of the daily target that belongs to this group. All groups together should add up to 100%.",
    "How many separate feed deliveries happen inside this group. More visits = smaller portions each time.":
      "How many separate feed deliveries happen inside this group. More visits = smaller portions each time.",
    Fish: "Fish",
    System: "System",
    "Feed line": "Feed line",
    "Relative Activity": "Relative Activity",
    "Trend (Short)": "Trend (Short)",
    "Trend (Med)": "Trend (Med)",
    "Trend (Long)": "Trend (Long)",
    "# of Fish": "# of Fish",
    "Relative Visibility": "Relative Visibility",
    Schooling: "Schooling",
    Distance: "Distance",
    Speed: "Speed",
    "Feed (kg/min)": "Feed (kg/min)",
    "Feed (g/s)": "Feed (g/s)",
    "Feed (p/fish/min)": "Feed (p/fish/min)",
    "Feed (kg/t/min)": "Feed (kg/t/min)",
    "Total Feed": "Total Feed",
    "Feed Score": "Feed Score",
    "Appetite Adjustment": "Appetite Adjustment",
    "Visit Feed (g)": "Visit Feed (g)",
    "Visit Number": "Visit Number",
    "Remaining Visits": "Remaining Visits",
    Salinity: "Salinity",
    Saturation: "Saturation",
    Pressure: "Pressure",
    "Average Weight": "Average Weight",
    "Condition Factor": "Condition Factor",
    "Coefficient of Variation": "Coefficient of Variation",
    "Specific Growth Rate": "Specific Growth Rate",
    "Relative Growth Index": "Relative Growth Index",
    "Growth Rate": "Growth Rate",
    "Total Lice": "Total Lice",
    "Air Speed (m/s)": "Air Speed (m/s)",
    "Water Flow (m³/h)": "Water Flow (m³/h)",
    "Water Flow [m³/h]": "Water Flow [m³/h]",
    "Silo Level (%)": "Silo Level (%)",
    "Line status": "Line status",
    Compare: "Compare",
    "Total feed amount compared to yesterday":
      "Total feed amount compared to yesterday",
    Today: "Today",
    Yesterday: "Yesterday",
    "Hide from chart": "Hide from chart",
    "Show in chart": "Show in chart",
    Feedline: "Feedline",
    Schedules: "Schedules",
    Active: "Active",
    OK: "OK",
    "is required": "is required",
    "must be a number": "must be a number",
    "must be at least": "must be at least",
    "must be at most": "must be at most",
    "must be greater than": "must be greater than",
    "must be a whole number": "must be a whole number",
    "can have at most": "can have at most",
    "decimal place": "decimal place",
    "decimal places": "decimal places",
    Discard: "Discard",
    Finish: "Finish",
    Overshoot: "Overshoot",
    Scheduler: "Scheduler",
    sec: "sec",
    min: "min",
    "Feed Now": "Feed Now",
    "Add Back": "Add Back",
    "Apply to All": "Apply to All",
    "Catch Up": "Catch Up",
    "Start Time": "Start Time",
    "End Time": "End Time",
    "Planned Feed": "Planned Feed",
    "Target Feed": "Target Feed",
    "Percentage Total": "Percentage Total",
    "New Schedule": "New Schedule",
    "Wait Block": "Wait Block",
    "Advanced Settings": "Advanced Settings",
    "Schedule name": "Schedule name",
    "Time Between Visits": "Time Between Visits",
    "Reset feed strategy on meal start": "Reset feed strategy on meal start",
    "Feed line settings": "Feed line settings",
    "Schedule: {{name}}": "Schedule: {{name}}",
    "At the start of each meal, pens return to the Start scenario of their feed strategy.":
      "At the start of each meal, pens return to the Start scenario of their feed strategy.",
    "Minimum time to wait between consecutive feeding visits to this pen when go to next is triggered. Visits are spaced so the feeder pauses at least this long before feeding.":
      "Minimum time to wait between consecutive feeding visits to this pen when go to next is triggered. Visits are spaced so the feeder pauses at least this long before feeding.",
    "Save schedule?": "Save schedule?",
    "Are you sure you want to save the changes to this schedule?":
      "Are you sure you want to save the changes to this schedule?",
    "Planned feed deviates from expected":
      "Planned feed deviates from expected",
    "Review feed deviation warnings before saving":
      "Review feed deviation warnings before saving",
    "Cannot save schedule": "Cannot save schedule",
    "Resolve the following errors before saving":
      "Resolve the following errors before saving",
    "Save Anyway": "Save Anyway",
    "Decrease Feed Rate or Feed Time": "Decrease Feed Rate or Feed Time",
    "Increase Feed Rate or Feed Time": "Increase Feed Rate or Feed Time",
    "This will clear all visits for this feed line":
      "This will clear all visits for this feed line",
    "No Feedline Found": "No Feedline Found",
    "No Feedlines Found": "No Feedlines Found",
    "No Pens Found": "No Pens Found",
    "No Schedules Found": "No Schedules Found",
    "All unsaved changes will be lost.": "All unsaved changes will be lost.",
    "You have unsaved changes to this group. Closing will discard them.":
      "You have unsaved changes to this group. Closing will discard them.",
    "There is currently no selected active schedule for this feedline":
      "There is currently no selected active schedule for this feedline",
    "Group percentages must add up to 100%":
      "Group percentages must add up to 100%",
    "Every group must have at least one visit":
      "Every group must have at least one visit",
    "At least one pen must stay in the plan":
      "At least one pen must stay in the plan",
    "Start time is required": "Start time is required",
    "End time is required": "End time is required",
    "Visits must be greater than 0": "Visits must be greater than 0",
    "Percentage must be at least 0": "Percentage must be at least 0",
    "Cannot exceed {{max}}%": "Cannot exceed {{max}}%",
    "Planned feed is {{percent}}% above expected":
      "Planned feed is {{percent}}% above expected",
    "Planned feed is {{percent}}% below expected":
      "Planned feed is {{percent}}% below expected",
    "Cage {{cageId}}": "Cage {{cageId}}",
    "Fix: {{fix}}": "Fix: {{fix}}",
    'This will permanently delete the schedule "{{name}}". This action cannot be undone.':
      'This will permanently delete the schedule "{{name}}". This action cannot be undone.',
    "{{count}} seconds_one": "{{count}} second",
    "{{count}} seconds_other": "{{count}} seconds",
    Continue: "Continue",
    "Saved — with changes": "Saved — with changes",
    "Your change was saved. The following adjustments were made:":
      "Your change was saved. The following adjustments were made:",
    "Fed so far: {{fedKg}} kg": "Fed so far: {{fedKg}} kg",
    "Planned: {{plannedKg}} kg": "Planned: {{plannedKg}} kg",
    "Target: {{targetKg}} kg": "Target: {{targetKg}} kg",
    "Overshoot: {{overshootPct}} %": "Overshoot: {{overshootPct}} %",
    "Planned Feed - {{plannedKg}} kg": "Planned Feed - {{plannedKg}} kg",
    "Target Feed - {{targetKg}} kg": "Target Feed - {{targetKg}} kg",
    "Overshoot - {{overshootPct}} %": "Overshoot - {{overshootPct}} %",
    Cluster: "Cluster",
    "op.itemDesc": "{{type}} {{start}}-{{end}} ({{pen}})",
    "op.dayWindow.outsideDay":
      "{{item}} falls outside the feeding window ({{dayStart}}-{{dayEnd}}). Move or shorten it to fit within those hours.",
    "op.dayWindow.outsideGroup":
      "{{item}} falls outside its feeding group window ({{groupStart}}-{{groupEnd}}). Move or shorten it to fit within those hours.",
    "op.adjacent.snappedLine":
      "{{item}} was adjusted to start at {{legalStart}} so it lines up directly after {{other}} on the shared feed line.",
    "op.adjacent.snappedPen":
      "{{item}} was adjusted to start at {{legalStart}} so it lines up directly after {{other}} in the same pen.",
    "op.contention.overlapLine":
      "{{item}} overlaps {{other}} on the shared feed line — only one visit can run on it at a time.",
    "op.contention.overlapPen":
      "{{item}} overlaps {{other}} in the same pen — clusters cannot overlap.",
    "op.contention.blowerGap":
      "{{item}} starts only {{gap}}s after {{other}} on the shared feed line. Different pens need at least {{requiredGap}}s between visits for the line to clear — space them further apart.",
    "op.inverted":
      "{{item}} ends at or before it starts. Give it an end time later than its start.",
    "op.waitBlock":
      "{{item}} starts during a wait block ({{blockStart}}-{{blockEnd}}). The wait block will be shortened to end when the visit begins.",
    "op.groupWindow.noGroup":
      "{{item}} doesn't fall inside any feeding group for this pen. Move it into a feeding group's hours to save.",
    "op.groupWindow.trimmed":
      "{{item}} was shortened to {{start}}-{{end}} ({{minutes}} min) to fit inside its feeding group ({{groupStart}}-{{groupEnd}}).",
    "op.dailyTarget.exceeded":
      "{{pen}} is set to feed {{plannedKg}} kg. The daily target is {{targetKg}} kg — remove or shorten a visit to bring it down.",
    "op.dailyTarget.noTarget":
      "{{pen}} has no feed target for today, so its operational target cannot be saved.",
    "op.dailyTarget.notInPlan":
      "Pen {{cageId}} is not in the plan for feedline {{feedLineId}}",
    "op.schedule.notOnFeedline":
      "The schedule loaded for {{feedLineId}} is not that feed line's active schedule. Refresh the page and make the change again.",
    "fineTune.diff.feedRate": "Feed rate",
    "fineTune.diff.target": "Target",
    "fineTune.diff.order": "Order",
    "fineTune.diff.groupVisits": "Group {{n}} visits",
    "fineTune.diff.removed": "Removed from plan",
    "fineTune.diff.added": "Added back to plan",
    "fineTune.title": "Fine-tune schedule",
    "fineTune.subtitle": "From default {{name}}",
    "fineTune.matchesDefault": "Matches default",
    "fineTune.changes_one": "{{count}} change",
    "fineTune.changes_other": "{{count}} changes",
    "fineTune.resetToDefault": "Reset to default",
    "fineTune.target": "Target",
    "fineTune.blowerGap": "Blower gap",
    "fineTune.seconds": "{{seconds}} s",
    "fineTune.feedRateUnit": "Feed Rate {{unit}}",
    "fineTune.targetKgSource": "Target kg · {{source}}",
    "fineTune.visitsPlanned": "Visits · Planned",
    "fineTune.removeFromPlan": "Remove from plan",
    "fineTune.addBackToPlan": "Add back to plan",
    "fineTune.reset": "Reset",
    "fineTune.done": "Done",
    "fineTune.window": "Window",
    "fineTune.share": "Share",
    "fineTune.removedFromPlan": "Removed from plan",
    "fineTune.removedBar": "Removed from plan · other pens planned without it",
    "fineTune.growthSwitched":
      "Target switched from growth model. Every pen keeps its own target.",
    "fineTune.footerNote":
      "Nothing is live until you save. Saving replaces today's schedule for {{line}}.",
    "fineTune.groupShort": "G{{n}}",
    "fineTune.groupName": "Group {{n}}",
    "fineTune.moveEarlier": "Feed {{pen}} earlier",
    "fineTune.moveLater": "Feed {{pen}} later",
    "fineTune.lowerRate": "Lower rate",
    "fineTune.raiseRate": "Raise rate",
    "fineTune.fewerVisits": "Fewer visits",
    "fineTune.moreVisits": "More visits",
    "fineTune.discardTitle": "Discard your changes?",
    "fineTune.discardDescription":
      "Your fine-tuning has not been saved. Closing now loses it.",
    "fineTune.discardConfirm": "Discard",
    "fineTune.defaultNotActive":
      "{{line}} no longer runs {{default}}. Close this and choose the default again.",
    "fineTune.resetStrategySaveFailed":
      "The schedule was saved, but the reset feed strategy on meal start setting was not: {{message}}",
    "siteOverview.apply": "Apply",
    "siteOverview.fineTune": "Fine-tune",
    "siteOverview.removeDefaultTitle": "Remove the default from {{line}}?",
    "siteOverview.removeDefaultDescription": "Its schedule stops.",
    "siteOverview.removeDefaultConfirm": "Remove",
    "siteOverview.replaceTitle": "Fine-tuning on {{line}} will be replaced",
    "siteOverview.replaceConfirm": "Continue",
    "siteOverview.drawerEditing":
      "The scheduler has unsaved edits. Save or cancel them before applying or fine-tuning a default.",
    "siteOverview.removeDefaultFailed":
      "Could not remove the default from {{line}}: {{message}}",
    "Live Pellets": "Live Pellets",
    "Co-pilot": "Co-pilot",
    "Feed Amount (Kg)": "Feed Amount (Kg)",
    "Temperature (°C)": "Temperature (°C)",
    "Visits Total": "Visits Total",
    "Pipe Pressure Bar": "Pipe Pressure Bar",
    "Oxygen (mg/L)": "Oxygen (mg/L)",
    "Feed Mode": "Feed Mode",
    "Line Status": "Line Status",
    "Visit (Kg)": "Visit (Kg)",
    "Next Scenario": "Next Scenario",
    AF: "AF",
    Table: "Table",
    Timeline: "Timeline",
    "How much in Kg has been fed this visit":
      "How much in Kg has been fed this visit",
    "How much in Kg has been fed today": "How much in Kg has been fed today",
    "Lets you visualise the graph(s) selected in the column selector, for current feed rate and/or pressure for each pen":
      "Lets you visualise the graph(s) selected in the column selector, for current feed rate and/or pressure for each pen",
    "CO-PILOT": "CO-PILOT",
    "This feature lets you run predefined strategies to achieve better results with less manual effort.":
      "This feature lets you run predefined strategies to achieve better results with less manual effort.",
    "Use this table to change strategy, scenario, or feed mode while in copilot mode. Toggle off co-pilot in this table to bring the pen back to manual feeding mode.":
      "Use this table to change strategy, scenario, or feed mode while in copilot mode. Toggle off co-pilot in this table to bring the pen back to manual feeding mode.",
    "FEED PAGE": "FEED PAGE",
    "This page helps you manage line statuses, feed rates, and the Co-pilot function.":
      "This page helps you manage line statuses, feed rates, and the Co-pilot function.",
    "This Screen": "This Screen",
    "Entire Setup": "Entire Setup",
    "No templates saved yet": "No templates saved yet",
    "Save Current Layout": "Save Current Layout",
    "Save Current Screen…": "Save Current Screen…",
    "Save Layout Template": "Save Layout Template",
    "Save Screen Layout Template": "Save Screen Layout Template",
    "Template Name": "Template Name",
    "Enter template name...": "Enter template name...",
    "Please enter a template name": "Please enter a template name",
    "Template name must be 50 characters or less":
      "Template name must be 50 characters or less",
    "Save Template": "Save Template",
    "Delete Template": "Delete Template",
    "Delete Screen Template": "Delete Screen Template",
    'Are you sure you want to delete the template "{{templateName}}"? This action cannot be undone.':
      'Are you sure you want to delete the template "{{templateName}}"? This action cannot be undone.',
    "Select Template": "Select Template",
    "Loading...": "Loading...",
    "Deleting...": "Deleting...",
    Surface: "Surface",
    Barge: "Barge",
    Other: "Other",
    Subsurface: "Subsurface",
    "Subsurface - top (looking up)": "Subsurface - top (looking up)",
    "Subsurface - bottom (looking down)": "Subsurface - bottom (looking down)",
    "Camera Model": "Camera Model",
    "Connect Exit Good to a scenario before saving its conditions":
      "Connect Exit Good to a scenario before saving its conditions",
    "Connect Exit Bad to a scenario before saving its conditions":
      "Connect Exit Bad to a scenario before saving its conditions",
    "Add an exit condition before adding a pause":
      "Add an exit condition before adding a pause",
    "4-digit PIN": "4-digit PIN",
    "Back to saved accounts": "Back to saved accounts",
    "Change PIN": "Change PIN",
    "Choose a PIN": "Choose a PIN",
    "Choose an account to continue.": "Choose an account to continue.",
    "Confirm your PIN": "Confirm your PIN",
    "Couldn't set up your PIN.": "Couldn't set up your PIN.",
    "Enter the same 4 digits again.": "Enter the same 4 digits again.",
    "Enter your PIN": "Enter your PIN",
    "Enter your password": "Enter your password",
    "Failed to cancel sign-in": "Failed to cancel sign-in",
    "Failed to forget this email": "Failed to forget this email",
    "Failed to reset password": "Failed to reset password",
    "Failed to set new password": "Failed to set new password",
    "Failed to set up authenticator": "Failed to set up authenticator",
    "Failed to start password reset": "Failed to start password reset",
    "Failed to verify code": "Failed to verify code",
    "Forget this email": "Forget this email",
    "Forgot password?": "Forgot password?",
    "Incorrect PIN.": "Incorrect PIN.",
    "Attempts left:": "Attempts left:",
    "Log in": "Log in",
    "Log in with a different email": "Log in with a different email",
    "Log in with password": "Log in with password",
    "Not now": "Not now",
    "Offline login isn't available on this device yet. Log in online first.":
      "Offline login isn't available on this device yet. Log in online first.",
    PIN: "PIN",
    Password: "Password",
    "Password login needs an internet connection.":
      "Password login needs an internet connection.",
    "Pick 4 digits you will remember. Used on this device only.":
      "Pick 4 digits you will remember. Used on this device only.",
    "Set up PIN": "Set up PIN",
    "Set up quick login?": "Set up quick login?",
    "Sign-in failed": "Sign-in failed",
    "Signing in as": "Signing in as",
    "Skip for now": "Skip for now",
    "Skip typing your password next time — sign in with a 4-digit PIN on this device.":
      "Skip typing your password next time — sign in with a 4-digit PIN on this device.",
    "Those PINs did not match. Start again.":
      "Those PINs did not match. Start again.",
    "Too many incorrect attempts. Log in with your password when you're back online.":
      "Too many incorrect attempts. Log in with your password when you're back online.",
    "Too many incorrect attempts. Log in with your password.":
      "Too many incorrect attempts. Log in with your password.",
    "Welcome back": "Welcome back",
    "Your offline session has expired. Log in with your password when you're back online.":
      "Your offline session has expired. Log in with your password when you're back online.",
    "Your password has been reset. Please log in.":
      "Your password has been reset. Please log in.",
    "Your password must be reset before you can log in.":
      "Your password must be reset before you can log in.",
    "Your quick login has expired. Log in with your password to renew it.":
      "Your quick login has expired. Log in with your password to renew it.",
    copilot_started_one: "Co-Pilot started for {{count}} pen",
    copilot_started_other: "Co-Pilot started for {{count}} pens",
    copilot_stopped_one: "Co-Pilot stopped for {{count}} pen",
    copilot_stopped_other: "Co-Pilot stopped for {{count}} pens",
    copilot_start_failed_one:
      "Failed to start Co-Pilot for {{count}} pen: {{pens}}",
    copilot_start_failed_other:
      "Failed to start Co-Pilot for {{count}} pens: {{pens}}",
    copilot_stop_failed_one:
      "Failed to stop Co-Pilot for {{count}} pen: {{pens}}",
    copilot_stop_failed_other:
      "Failed to stop Co-Pilot for {{count}} pens: {{pens}}",
    copilot_start_partial_one:
      "Co-Pilot strategy set, but other steps failed for {{count}} pen: {{pens}}",
    copilot_start_partial_other:
      "Co-Pilot strategy set, but other steps failed for {{count}} pens: {{pens}}",
    copilot_stop_partial_one:
      "Co-Pilot strategy reset, but other steps failed for {{count}} pen: {{pens}}",
    copilot_stop_partial_other:
      "Co-Pilot strategy reset, but other steps failed for {{count}} pens: {{pens}}",
    copilot_half_on_one:
      "Co-Pilot strategy set but auto-feeding could not be enabled for {{pens}} — it will not feed; re-run Start Co-Pilot for this pen",
    copilot_half_on_other:
      "Co-Pilot strategy set but auto-feeding could not be enabled for {{pens}} — they will not feed; re-run Start Co-Pilot for these pens",
    copilot_more_pens: "+{{remaining}} more",
    copilot_stage_auto_feeding_flag: "auto-feeding flag",
    copilot_stage_feed_mode: "feed mode",
    copilot_stage_default_reset: "default reset",
    copilot_stage_strategy: "strategy",
    copilot_stage_strategy_reset: "strategy reset",
    copilot_stage_unexpected_error: "unexpected error",
    Duplicate: "Duplicate",
    "Default options": "Default options",
    "GROWTH MODEL FEED TARGET": "GROWTH MODEL FEED TARGET",
    "FIXED FEED TARGET": "FIXED FEED TARGET",
    "Delete Template?": "Delete Template?",
    "Deleting this template also deletes every schedule it created on a feedline. This action cannot be undone.":
      "Deleting this template also deletes every schedule it created on a feedline. This action cannot be undone.",
    "Checking schedules\u2026": "Checking schedules…",
    "Could not load the schedules this template created. Deleting it will still remove them.":
      "Could not load the schedules this template created. Deleting it will still remove them.",
    "No schedules use this template.": "No schedules use this template.",
    ACTIVE: "ACTIVE",
    '"{{name}}" template deleted': '"{{name}}" template deleted',
    '"{{name}}" template deleted with {{count}} schedules_one':
      '"{{name}}" template deleted with {{count}} schedule',
    '"{{name}}" template deleted with {{count}} schedules_other':
      '"{{name}}" template deleted with {{count}} schedules',
  },
};
